import { render, staticRenderFns } from "./widget-formation.vue?vue&type=template&id=5b34632e&"
import script from "./widget-formation.vue?vue&type=script&lang=js&"
export * from "./widget-formation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports